// import Client from 'shopify-buy';

// export const shopifyBuyClient: Client.Client = Client.buildClient({
//   domain: 'olea-collection.myshopify.com',
//   storefrontAccessToken: 'd360ee804c40e46715eff2e6ed1b6216',
// });

import {
  createStorefrontApiClient,
  StorefrontApiClient,
} from '@shopify/storefront-api-client';

const shopifyClient: StorefrontApiClient = createStorefrontApiClient({
  storeDomain: 'olea-collection.myshopify.com',
  apiVersion: '2025-04',
  publicAccessToken: 'd360ee804c40e46715eff2e6ed1b6216',
});

export default shopifyClient;
